module.exports = __webpack_public_path__ + "static/media/reachedTournamentTop10_35_50.0a5555b3.png";